export const experiments = [
  {
    name: 'hotmart-new-hero-image',
    experimentID: '66hKvYTTT0CZDeelDlZ73Q',
    expirationDate: new Date('12/31/2022').getTime(),
    variants: [
      { weight: 50 }, // Default variant
      { weight: 50 },
    ],
  },
]

export default experiments
